export const validations = {
  tireSize: [{ type: 'required' }, { type: 'numeric' }],
  variableAccelAccel1: [{ type: 'required' }, { type: 'numeric' }],
  variableAccelAccel2: [{ type: 'required' }, { type: 'numeric' }],
  variableAccelSpeed1: [{ type: 'required' }, { type: 'numeric' }],
  variableAccelSpeed2: [{ type: 'required' }, { type: 'numeric' }],
  maxRoadSpeedTrim2: [{ type: 'required' }, { type: 'numeric' }],
  globalRoadSpeedMaximum: [{ type: 'required' }, { type: 'numeric' }]
};
